import { render } from "./MainSales.vue?vue&type=template&id=0e579bcc&scoped=true"
import script from "./MainSales.vue?vue&type=script&lang=js"
export * from "./MainSales.vue?vue&type=script&lang=js"

import "./MainSales.vue?vue&type=style&index=0&id=0e579bcc&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e579bcc"]])

export default __exports__